// NOTE: wiki プレフィックスがついてしまってるパスに変換し、このパスにクローラーを呼び込むための一時的な処理です。したがって、この対応が終了したらこの処理は削除します。
// REF: https://app.asana.com/1/941909390465892/project/1202642188581172/task/1209933364659406?focus=true

const tmpWikiPrefixPaths = require('./tmpWikiPrefixPaths');

// NOTE: プロセスキャッシュに残すためここでセットを作成
const wikiPrefixPathSet = new Set(tmpWikiPrefixPaths);

module.exports = function markdownItAddWikiPrefix(md) {
  const defaultRender =
    md.renderer.rules.link_open ||
    function (tokens, idx, options, env, self) {
      return self.renderToken(tokens, idx, options);
    };

  md.renderer.rules.link_open = function (tokens, idx, options, env, self) {
    const token = tokens[idx];
    const hrefIndex = token.attrIndex('href');

    if (hrefIndex < 0) {
      return defaultRender(tokens, idx, options, env, self);
    }

    const hrefValue = token.attrs[hrefIndex][1];

    if (wikiPrefixPathSet.has(`https://kamigame.jp/wiki${hrefValue}`)) {
      token.attrs[hrefIndex][1] = `/wiki${hrefValue}`;
    }

    return defaultRender(tokens, idx, options, env, self);
  };
};
